module.exports = __webpack_public_path__ + "img/ra-logo.0d06e201.png";